<template>
  <div class="d-flex flex-column justify-content-start align-items-start">
    <span class="badge badge-pill" :class="currentStatus">
      {{statusText}}
    </span>
    <small class="text-muted">{{expiredDate}}</small>
  </div>
</template>

<script>
export default {
  name: "ReferralStatus",
  props: ["status","expiredDate"],
  computed: {
    currentStatus() {
      switch (this.status) {
        case 'active':
          return 'badge-success';
        case 'expied':
          return 'badge-danger';
        default:
          return 'badge-danger';
      }
    },
    statusText() {
      switch (this.status) {
        case 'active':
          return 'Active';
        case 'expired':
          return 'Expired';
        default:
          return this.status;
      }
    },
  },
};
</script>